import { Component, computed, effect, inject, input, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NgClass } from '@angular/common';
import { Store } from '@ngrx/store';
import { NzIconService } from 'ng-zorro-antd/icon';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { AppStore } from '@aaa/emember/store-types';
import { DocumentRefService } from '../share/services/document-ref.service';
import { environment } from '../../../environments/environment';
import { selectUrl } from '../../store/router/router.selectors';
import { SpinnerComponent } from '../share/ava-spinner';
import { AnalyticsActions } from '../../store/analytics';
import { clubOption } from '../../signals';
import { ChildDataService } from './child-data.service';
import { TesterGate } from './components/tester-gate/tester-gate';
import { TesterGateService } from './components/tester-gate/tester-gate.service';

@Component({
  selector: 'ava-emember',
  standalone: true,
  template: `
    <div class="tw-block tw-bg-white tw-text-start">
      @if (testerGate.open()) {
        <router-outlet name="header" />
      }

      <div
        [ngClass]="clubOption()?.mainClass"
        class="-2xs:tw-px-1 -2xs:tw-py-0 -desk:tw-px-4 -desk:tw-py-0 -moblg:tw-px-2 -moblg:tw-py-0 "
        id="ava-emember"
      >
        @if (!testerGate.open()) {
          <ava-tester-gate />
        } @else {
          @if (url() !== '/' && showSpinner()) {
            <ava-spinner />
          }

          <router-outlet (activate)="onActive()" (deactivate)="onDeactivate()" />
        }
      </div>
    </div>
  `,
  imports: [RouterOutlet, SpinnerComponent, NgClass, TesterGate],
})
export class EmemberComponent {
  private static readonly CONTAINER_ID = 'ava-emember';

  store = inject(Store<AppStore>);
  nzIconService = inject(NzIconService);
  document = inject(DocumentRefService);
  router = inject(Router);
  childData = inject(ChildDataService);
  testerGate = inject(TesterGateService);

  embedded = input(false);

  clubOption = computed(() => clubOption());
  url = toSignal(this.store.select(selectUrl));
  showSpinner = signal(true);

  constructor() {
    this.nzIconService.changeAssetsSource(environment.baseHref);
    this.initScrollToTop();
    effect(() => this.childData.embedded.set(this.embedded()));
  }

  private initScrollToTop() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.onNavigationEnd();

        try {
          const [pathName = ''] = event.url.split('?');
          const eventName = pathName.split('/').filter(Boolean).join('-');

          if (eventName.startsWith('account')) {
            this.store.dispatch(AnalyticsActions.viewedPage({ eventName }));
          }
        } catch (e) {
          console.warn(e);
        }
      }

      if (!(event instanceof NavigationEnd)) {
        return;
      }
    });
  }

  private onNavigationEnd(): void {
    this.document.scrollToId(EmemberComponent.CONTAINER_ID);
  }

  onDeactivate() {
    this.showSpinner.set(true);
  }

  onActive() {
    this.showSpinner.set(false);
  }
}
